import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import "bootstrap/dist/js/bootstrap.bundle";
import "./vendor/bootstrap-select";
import "./nested_form_fields";
// import flatpickr from "flatpickr";
// import SimpleMDE from "simplemde";

$(function () {
  $('[data-toggle="tooltip"]').tooltip();

  $(".selectpicker.poly_select").each(function () {
    $(this).selectpicker(
      "val",
      $("#" + this.id + "_type").val() + ":" + $("#" + this.id + "_id").val()
    );
  });

  $(".datepicker").flatpickr({
    allowInput: true,
    altInput: true,
    altFormat: "d.m.Y",
    dateFormat: "Y-m-d",
    enableTime: false,
  });

  $(".datetimepicker").flatpickr({
    allowInput: true,
    altInput: true,
    altFormat: "d.m.Y H:i",
    dateFormat: "Y-m-d H:i",
    defaultHour: 19,
    enableTime: true,
    time_24hr: true,
    onChange: function (selectedDates, dateStr, instance) {
      if (instance.element.classList.contains("date-begin")) {
        const fp = $(
          ".flatpickr-input.date-end#" + instance.element.id.replace("begin", "end")
        )[0]._flatpickr;
        fp.config.minDate = selectedDates[0];
        if (fp.selectedDates.length === 0) {
          const d = selectedDates[0];
          d.setHours(d.getHours() + 2);
          fp.setDate(d);
        }
      }
    },
    onReady: function (selectedDates, dateStr, instance) {
      if (instance.element.classList.contains("date-end")) {
        const begin_id = instance.element.id.replace("end", "begin");
        instance.config.minDate = document.getElementById(begin_id).value;
      }
    },
  });

  const dateTimeToggler = $("input.date-time-toggler");
  if (dateTimeToggler.length) {
    toggleDateTime(dateTimeToggler.prop("checked"));
  }
  dateTimeToggler.change(function (e) {
    toggleDateTime(e.target.checked);
  });

  // const eventDescSimplemde = new SimpleMDE({
  //   hideIcons: ["image", "horizontal-rule", "side-by-side", "fullscreen"],
  //   spellChecker: false,
  //   element: document.getElementById("event_description"),
  // });

  if (localStorage.getItem("darkmodeOn") == "true") {
    $("body").addClass("dark");
  }
  $("button.darkmode-toggler").click(function () {
    $("body").toggleClass("dark");
    localStorage.setItem("darkmodeOn", $("body").hasClass("dark"));
  });

  if (localStorage.getItem("sidebarOn") == "true") {
    $("#mr-wrapper").addClass("full-sb");
    setTimeout(function () {
      $("#mr-wrapper").addClass("sb-ready");
    });
  } else {
    $("#mr-wrapper").addClass("sb-ready");
  }

  $("#mr-wrapper.full-sb #mr-sidebar [data-toggle='tooltip']").tooltip("disable");

  $(".add_nested_fields_link").click(function () {
    setTimeout(function () {
      $(".selectpicker").selectpicker();
    }, 10);
  });

  $(".parent a").click(function () {
    $("#mr-wrapper").addClass("full-sb");
    $(".parent a").not($(this)).parent().removeClass("open");
    $(this).parent().toggleClass("open");
    $(".parent a").not($(this)).parent().children("ul").slideUp();
    $(this).parent().children("ul").slideToggle();
    $("#mr-sidebar [data-toggle='tooltip']").tooltip("disable");
  });

  $(".sidebar-toggler").click(function () {
    $("#mr-wrapper").toggleClass("full-sb");
    localStorage.setItem("sidebarOn", $("#mr-wrapper").hasClass("full-sb"));
    $("#mr-sidebar [data-toggle='tooltip']").tooltip("toggleEnabled");
    $(".parent a").parent().removeClass("open");
    $(".parent a").parent().children("ul").css("display", "none");
  });

  $("#johnny-rainbow").dblclick(function () {
    $("body").toggleClass("disco");
  });

  $(".wiki_content a[href^='#']").click(function (e) {
    e.preventDefault();
    const margin = 20;
    const pos =
      $($(this).attr("href")).offset().top -
      $("nav.navbar.fixed-top").outerHeight() -
      margin;
    $("html, body").animate({ scrollTop: pos }, 800, "swing");
  });

  $("a").click(function (e) {
    const href = $(this).attr("href");
    if (!href) return;
    const url = new URL(href, window.location.origin);
    if (
      url.protocol === "http:" ||
      (url.protocol === "https:" &&
        !url.hostname.endsWith(".rotaract.de") &&
        url.origin !== window.location.origin)
    ) {
      const confirmed = confirm(
        "Du verlässt nun mein Rotaract und besuchst \n" +
          url.href +
          "\n\nBist du sicher?"
      );
      if (!confirmed) {
        e.preventDefault();
      }
    }
  });
});

window.setPolyType = function (elem) {
  $("#" + elem.id + "_type").val(elem.value.split(":")[0]);
  $("#" + elem.id + "_id").val(elem.value.split(":")[1]);
};

window.toggleDateTime = function (noTime) {
  $(".datetimepicker.flatpickr-input").each(function () {
    const fp = this._flatpickr;
    fp.set("dateFormat", noTime ? "Y-m-d" : "Y-m-d H:i");
    fp.set("altFormat", noTime ? "d.m.Y" : "d.m.Y H:i");
    fp.set("enableTime", !noTime);
  });
};
